import React, { useState, useEffect, useRef } from "react";
import { ReactSVG } from "react-svg";
import { render } from "react-dom";
import { AppVersion } from "@/kyna/lib/StandardReferences";
import { AiFillYoutube } from "react-icons/ai";
import Image from "next/image";
import Link from "next/link";

// import AppLogo from '../../../public/assets/img/app-logo.png';
import AppLogo from "../../public/assets/img/app-logo.png";
// import FBicon from '../../public/assets/img/facebook.png';
// import IGicon from '../../public/assets/img/instagram.png';
// import Twittericon from '../../public/assets/img/twitter.png';

import FBicon from "public/assets/img/icons/facebook-icon.svg";
import Twittericon from "public/assets/img/icons/twitter-icon.svg";
import IGicon from "public/assets/img/icons/instagram-icon.svg";
import YTicon from "public/assets/img/icons/youtube-icon.svg";
import TikTokicon from "public/assets/img/icons/tiktok-icon.svg";

import LocationIcon from "../../public/assets/img/icons/location-icon.svg";
import ClockIcon from "../../public/assets/img/icons/clock-icon.svg";
import EmailIcon from "../../public/assets/img/icons/email-icon.svg";
import CORSeal from "../../public/assets/img/NPC-CORSeal-2026.png";
import NPCRegistrationCert from "../../public/assets/img/NPC-Registration-Cert-2026.jpg";
import KNModal from "@/kyna/ui/modal/KNModal";

import store from "store2";

const UserSession = store.get("UserSession");

function Footer(props) {
  const [isCertModalOpen, setIsCertModalOpen] = useState(false);

  return (
    <div className="">
      <section
        id="footer-section"
        className="xl:container pt-12 pb-10 mx-auto md:px-10 sm:px-8 px-6 border-t border-gray-300"
      >
        {/* <div className='flex-1 items-center'> */}
        <div className="grid xl:grid-cols-5 lg:grid-cols-4 grid-cols-2 md:gap-5 sm:gap-8 gap-4 mb-20">
          <div className="xl:col-span-2 sm:col-span-1 col-span-2">
            <Link href="/">
              <a className="app-logo max-w-[100px] sm:mx-0 mx-auto mb-4 block">
                <Image src={AppLogo} alt="AppLogo" />
              </a>
            </Link>
            <h2 className="text-blue text-base sm:text-left text-center mb-1">
              Philippine Mental Health Association, Inc.
            </h2>
            <p className="max-w-[250px] sm:text-left text-center sm:mx-0 mx-auto">
              18 East Ave, Diliman, Quezon City, 1100 Metro Manila
            </p>
          </div>
          <div className="col-span-1 text-left">
            <h4 className="font-medium mb-5 text-base text-blue">Quicklinks</h4>
            <ul>
              <li className="sm:mb-5 mb-3">
                <Link href="/about">
                  <a className="text-gray-500">About</a>
                </Link>
              </li>
              <li className="sm:mb-5 mb-3">
                <Link href="/news-and-events">
                  <a className="text-gray-500">News</a>
                </Link>
              </li>
              <li className="sm:mb-5 mb-3">
                <Link href="/careers">
                  <a className="text-gray-500">Careers</a>
                </Link>
              </li>
              <li className="sm:mb-5 mb-3">
                <Link href="/membership">
                  <a className="text-gray-500">Become a member</a>
                </Link>
              </li>
              <li className="sm:mb-5 mb-3">
                <Link href="/donations">
                  <a className="text-gray-500">Donate Now</a>
                </Link>
              </li>
              <li className="sm:mb-5 mb-3">
                {UserSession != null ? (
                  <Link href="/app/dashboard">
                    <a className="text-gray-500">Dashboard</a>
                  </Link>
                ) : (
                  <Link href="/account/login">
                    <a className="text-gray-500">Login</a>
                  </Link>
                )}
              </li>
            </ul>
          </div>
          <div className="col-span-1 text-left">
            <h4 className="font-medium mb-5 text-base text-blue">
              Programs and Services
            </h4>
            <ul>
              <li className="sm:mb-5 mb-3">
                <Link href="/education-and-advocacy-department">
                  <a className="text-gray-500">
                    Education and Advocacy Department
                  </a>
                </Link>
              </li>
              <li className="sm:mb-5 mb-3">
                <Link href="/clinical-and-intervention-services-department">
                  <a className="text-gray-500">
                    Clinical and Intervention Services Department
                  </a>
                </Link>
              </li>
              <li className="sm:mb-5 mb-3">
                <Link href="/monitoring-evaluation-and-research-department">
                  <a className="text-gray-500">
                    Monitoring, Evaluation, and Research Department
                  </a>
                </Link>
              </li>
            </ul>
          </div>
          <div className="sm:col-span-1 col-span-2 text-left">
            <div className="flex mb-3">
              <div className="w-[14px] mt-[3px]">
                <Image src={EmailIcon} alt="Email" />
              </div>
              <div className="pl-3">
                <Link href="mailto:hello@pmha.org.ph">
                  <a className="text-black/70">hello@pmha.org.ph</a>
                </Link>
              </div>
            </div>
            <div className="flex mb-5">
              <div className="w-[16px] mt-[2px]">
                <Image src={ClockIcon} alt="Clock" />
              </div>
              <div className="pl-3">
                <p>Office Schedule:</p>
                <p>Monday - Friday (7:00AM- 4:00PM)</p>
              </div>
            </div>
            <div
              className="max-w-[100px] cursor-pointer"
              onClick={() => setIsCertModalOpen(true)}
            >
              <Image src={CORSeal} alt="CORSeal" />
            </div>
          </div>
        </div>

        {/* footer */}
        <div className="grid lg:grid-cols-12 grid-cols-1 gap-4">
          <div className="lg:col-span-10 col-span-1 items-center text-left lg:mb-0 mb-2">
            <div className="flex items-center gap-2 flex-wrap mb-2">
              <p className="uppercase text-sm text-left tracking-wider">
                PMHA © {new Date().getFullYear()}. All Rights Reserved.
              </p>
              <ul className="flex items-center gap-2 flex-wrap">
                <li className="uppercase text-sm tracking-wider">
                  <Link href="/privacy-policy">
                    <a className="text-gray-500">Privacy Policy</a>
                  </Link>
                </li>
                <li>•</li>
                <li className="uppercase text-sm tracking-wider">
                  <Link href="/terms-and-conditions">
                    <a className="text-gray-500">Terms and Conditions</a>
                  </Link>
                </li>
              </ul>
            </div>
            <div className="text-gray-500 text-sm uppercase tracking-wider">
              Powered by{" "}
              <Link href="https://kynatech.ph/">
                <a target="_blank">kynatech.ph</a>
              </Link>
            </div>
          </div>

          <div className="lg:col-span-2 col-span-1">
            <ul className="footer-social-icon text-right flex items-center mjustify-end gap-x-5">
              <li className="!w-[8px]">
                <a
                  href="https://www.facebook.com/PMHAofficial"
                  target={"_blank"}
                  rel="noreferrer"
                >
                  <Image src={FBicon} alt="Facebook" />
                </a>
              </li>
              <li className="">
                <a
                  href="https://twitter.com/PMHAofficial"
                  target={"_blank"}
                  rel="noreferrer"
                >
                  <Image src={Twittericon} alt="Twitter" />
                </a>
              </li>
              <li className="">
                <a
                  href="https://www.instagram.com/pmhaofficial/"
                  target={"_blank"}
                  rel="noreferrer"
                >
                  <Image src={IGicon} alt="Instagram" />
                </a>
              </li>
              <li className="">
                <a
                  href="https://www.youtube.com/channel/UCvZjwCE8FucFXNrcGjgPz_w"
                  target={"_blank"}
                  rel="noreferrer"
                >
                  <Image src={YTicon} alt="Youtube" />
                </a>
              </li>
              <li className="!w-[14px]">
                <a
                  href="https://www.tiktok.com/@pmhaofficial"
                  target={"_blank"}
                  rel="noreferrer"
                >
                  <Image src={TikTokicon} alt="Tiktok" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </section>

      <KNModal
        title={""}
        no_header={true}
        bodyClassPad={"!p-0"}
        isOpen={isCertModalOpen}
        noFooter={true}
        bodyClass={"cert-modal !max-w-5xl mt-10"}
        onOpen={() => {}}
        closeModal={() => setIsCertModalOpen(false)}
        body={
          <div className="w-full">
            <Image
              src={NPCRegistrationCert}
              alt="NPC Registration Certificate"
              layout="responsive"
            />
          </div>
        }
      />
    </div>
  );
}

export default Footer;
